export function toPercent(n: number): string {
    return `${n * 100}%`;
}